import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import UniqueBlock from './UniqueBlock'
import SectionWithTag from '../../../components/SectionWithTag'
import FadeIn from '../../../components/Animation/FadeIn'
import PaddingContext from '../../../utils/PaddingContext'
import MovingBackground from '../../../partials/MovingBackground/MovingBackground'
import Background from '../../../assets/backgrounds/unique-desktop.svg'
import BackgroundMobile from '../../../assets/backgrounds/unique-mobile.svg'

const id = 'page.epp.unique'

const data = [
    {
        id: 'performance',
    },
    {
        id: 'ownership',
    },
    {
        id: 'agnostic',
    },
    {
        id: 'likelihood',
    },
    {
        id: 'feasibility',
    },
    {
        id: 'build',
    },
]

const Unique = () => {
    const { padding } = useContext(PaddingContext)
    return (
        <div className='bg-purple-light relative border-t border-black/10 overflow-hidden'>
            <MovingBackground
                component={Background}
                mobileComponent={BackgroundMobile}
                classes={{ background: 'mix-blend-multiply' }}
                animate
            >
                <div className='py-12 md:py-30'>
                    <div className='relative'>
                        <SectionWithTag
                            tag={{ id: `${id}.tag` }}
                            className='3xl:max-w-screen-2xl mx-auto'
                            padding={padding}
                        >
                            <div className='max-w-[850px] mx-auto flex items-center py-10 md:p-0 md:ml-0'>
                                <FormattedMessage id={id} tagName='h2' />
                            </div>
                        </SectionWithTag>
                        <FadeIn>
                            <div className='side-padding 3xl:max-w-screen-2xl mx-auto'>
                                <div className='border-t border-black/10 text-left md:mt-20'>
                                    <div className='grid md:grid-cols-2 lg:grid-cols-3 content-grid-alt'>
                                        {data.map(({ id }) => (
                                            <UniqueBlock id={id} key={id} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </FadeIn>
                    </div>
                    <div className='md:pt-2 hidden'></div>
                </div>
            </MovingBackground>
        </div>
    )
}

export default Unique
